<template>
  <div id="page-user-edit">

    <vs-alert color="danger" title="User Not Found" :active.sync="event_not_found">
      <span>Event record with id: {{ $route.params.id }} not found. </span>
      <span>
        <span>Check </span><router-link :to="{name:'events'}" class="text-inherit underline">All Events</router-link>
      </span>
    </vs-alert>

    <vx-card v-if="event_data">

      <div slot="no-body" class="tabs-container px-6 pt-6">

        <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
          <vs-tab label="Event" icon-pack="feather" icon="icon-umbrella">
            <div class="tab-text">
              <user-edit-tab-account class="mt-4" :data="event_data" />
            </div>
          </vs-tab>
          <!--<vs-tab label="Information" icon-pack="feather" icon="icon-info">
            <div class="tab-text">
              <user-edit-tab-information class="mt-4" :data="event_data" />
            </div>
          </vs-tab>
          <vs-tab label="Social" icon-pack="feather" icon="icon-share-2">
            <div class="tab-text">
              <user-edit-tab-social class="mt-4" :data="event_data" />
            </div>
          </vs-tab>-->
        </vs-tabs>

      </div>

    </vx-card>
  </div>
</template>

<script>
import UserEditTabAccount     from './UserEditTabAccount.vue'
/*import UserEditTabInformation from "./UserEditTabInformation.vue"
import UserEditTabSocial      from "./UserEditTabSocial.vue"*/

// Store Module
import moduleAdmin from '@/store/admin/moduleAdmin.js'

export default {
  components: {
    UserEditTabAccount
    /*UserEditTabInformation,
    UserEditTabSocial*/
  },
  data () {
    return {
      event_data: null,
      event_not_found: false,

      /*
        This property is created for fetching latest data from API when tab is changed

        Please check it's watcher
      */
      activeTab: 0
    }
  },
  watch: {
    activeTab () {
      this.fetch_event_data(this.$route.params.id)
    }
  },
  methods: {
    fetch_event_data (eventId) {
      this.$store.dispatch('admin/fetchEvent', eventId)
        .then(res => { this.event_data = res.data.data })
        .catch(err => {
          if (err.response.status === 404) {
            this.event_not_found = true
            return
          }
          console.error(err)
        })
    }
  },
  created () {
    // Register Module UserManagement Module
    if (!moduleAdmin.isRegistered) {
      this.$store.registerModule('admin', moduleAdmin)
      moduleAdmin.isRegistered = true
    }
    this.fetch_event_data(this.$route.params.id)
  }
}

</script>
